module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.3@core-js/library/modules/_add-to-unscopables.js
// module id = 296
// module chunks = 0